import React from 'react';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import { COLOR } from '@src/styles/color';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Typography from '@src/new-components/Typography';
import { StyledRecordTime } from './index.style';

const getBackgroundColor = (isRecording, recordSuccess) => {
  if (isRecording && !recordSuccess) {
    return COLOR.backgroundError;
  }
  if (recordSuccess) {
    return COLOR.backgroundSuccess;
  }
  return COLOR.backgroundRecordTime;
};

const getIcon = (isRecording, recordSuccess) => {
  if (isRecording && !recordSuccess) {
    return <FiberManualRecordRoundedIcon sx={{ color: COLOR.errorDropZone }} />;
  }
  if (recordSuccess) {
    return <CheckCircleRoundedIcon sx={{ color: COLOR.success }} />;
  }
  return null;
};

const CountTime = ({ time, isRecording, recordSuccess }) => (
  <StyledRecordTime
    backgroundColor={getBackgroundColor(isRecording, recordSuccess)}
  >
    {getIcon(isRecording, recordSuccess)}
    <Typography
      component="span"
      variant="body-16-regular"
      color={isRecording ? COLOR.black.default : COLOR.descriptionUpload}
      style={{ width: '45px', textAlign: 'center' }}
    >
      {time}
    </Typography>
  </StyledRecordTime>
);

export default CountTime;
